import moment from "moment-timezone";
import Long from "long";

moment.locale("fr");

export default class TimeUtils {
  static getDateYear(date) {
    date = new Long(date.low, date.high, date.unsigned).toNumber();
    return moment(Number(date)).year();
  }

  static getTimeDifference(start, end) {
    const date1 = moment()
      .set({
        hour: parseInt(start.hour, 10),
        minutes: parseInt(start.minute, 10)
      })
      .valueOf();
    const date2 = moment()
      .set({ hour: parseInt(end.hour, 10), minutes: parseInt(end.minute, 10) })
      .valueOf();
    const result = Math.abs(date1 - date2) / 36e5;
    const tmp = 10 ** 1;
    return Math.round(result * tmp) / tmp;
  }

  static getTimeDifferenceBetween(startDate, endDate) {
    const result = Math.abs(startDate - endDate) / 36e5;
    const tmp = 10 ** 1;
    return Math.round(result * tmp) / tmp;
  }

  static getDateMonth(date) {
    date = new Long(date.low, date.high, date.unsigned).toNumber();
    return moment(Number(date)).month();
  }

  static getDateFrom(date, hour, minute) {
    return moment(date)
      .set({ hour: parseInt(hour, 10), minutes: parseInt(minute, 10) })
      .valueOf();
  }

  static compareRangeDates(referenceDate, rangeDateStart, rangeDateEnd) {
    referenceDate = new Long(referenceDate.low, referenceDate.high, referenceDate.unsigned).toNumber();
    const date = moment(Number(referenceDate));
    return date.isAfter(rangeDateStart) && !date.isAfter(rangeDateEnd);
  }

  static isFullDay(date) {
    if (typeof date != "number") {
      date = new Long(date.low, date.high, date.unsigned).toNumber();
    }
    const time = moment(parseInt(date, 10)).tz("Europe/Paris");
    if (time.hour() === 23) {
      return 1;
    } else if (time.hour() === 11) {
      return 2;
    }
    return 3;
  }

  static formatDate(date) {
    if (typeof date == "number") {
      return moment(Number(date))
      .tz("Europe/Paris")
      .format("DD/MM/YY");
    } else {
      date = new Long(date.low, date.high, date.unsigned).toNumber();
      return moment(Number(date))
        .tz("Europe/Paris")
        .format("DD/MM/YY");
    }
  }

  static formatDateForDailyReport(date) {
    return moment(Number(date))
      .tz("Europe/Paris")
      .format("MM/DD/YY");
  }

  static formatDateForCalander(date) {
    return moment(Number(date))
      .tz("Europe/Paris")
      .format("YYYY-MM-DD");
  }

  static formatDateString(date) {
    date = new Long(date.low, date.high, date.unsigned).toNumber();
    return moment(date)
      .tz("Europe/Paris")
      .format("YYYY-MM-DD");
  }

  static formatFullDay(date) {
    return (
      moment(date)
        // .tz("Europe/Paris")
        .format("Do MMMM YYYY")
    );
  }
  static GMTDate(date) {
    date = new Long(date.low, date.high, date.unsigned).toNumber();
    return moment(Number(date))
      .tz("Europe/Paris")
      .format("LLLL");
  }

  static getFirstHalfOfDay(date) {
    return moment(date)
      .tz("Europe/Paris")
      .set({ hour: 11, minutes: 0 });
  }

  static getMiddleOfDay(date) {
    return moment(date)
      .tz("Europe/Paris")
      .set({ hour: 13, minutes: 0 });
  }

  static getStartOfDay(date) {
    return moment(date)
      .tz("Europe/Paris")
      .startOf("day");
  }

  static getEndOfDay(date) {
    return moment(date)
      .tz("Europe/Paris")
      .endOf("day");
  }

  static formatDateTime(date) {
    date = new Long(date.low, date.high, date.unsigned).toNumber();
    return moment(Number(date))
      .tz("Europe/Paris")
      .format("ddd DD/MM/YY [à] HH[h]mm");
  }

  static formatTime(date) {
    return moment(Number(date)).format("HH:mm");
  }

  static formatMinutes(minutes) {
    if (!minutes) {
      return "00";
    }
    if (minutes == 2) return "10";
    else if (minutes == 3) return "20";
    else if (minutes == 5) return "30";
    else if (minutes == 7) return "40";
    else if (minutes == 8) return "50";
    return "00";
  }

  static formatPeriod(date) {
    date = new Long(date.low, date.high, date.unsigned).toNumber();
    return moment(Number(date)).format("MMM YY");
  }
  static formetDateDifference(startDate, endDate) {
    startDate = new Long(startDate.low, startDate.high, startDate.unsigned).toNumber();
    endDate = new Long(endDate.low, endDate.high, endDate.unsigned).toNumber();
    const start = moment(Number(startDate))
      .tz("Europe/Paris")
      .format("YYYY-MM-DD HH:mm");
    const end = moment(Number(endDate))
      .tz("Europe/Paris")
      .format("YYYY-MM-DD HH:mm");

    return Math.abs(
      moment(end, "YYYY-MM-DD")
      .startOf("day")
      .diff(moment(start, "YYYY-MM-DD")
      .startOf("day"), "days")
    ) === 0
      ? 0.5
      :     Math.abs(  moment(end, "YYYY-MM-DD")
      .startOf("day")
      .diff(moment(start, "YYYY-MM-DD")
      .startOf("day"), "days"));
  }

  static dayMonYear(date) {
    date = new Long(date.low, date.high, date.unsigned).toNumber();
    return moment(date)
      .tz("Europe/Paris")
      .format("DD.MM.YYYY");
  }

  static dayMonYearNumber(date) {
    date = new Long(date.low, date.high, date.unsigned).toNumber();
    return moment(Number(date))
      .tz("Europe/Paris")
      .format("DD.MM.YYYY");
  }

  static dayMonYearTime(date) {
    date = new Long(date.low, date.high, date.unsigned).toNumber();
    return moment(date)
      .tz("Europe/Paris")
      .format("DD.MM.YYYY HH:mm");
  }
}
